export const projectsData = [
    {
        title: "Larry Birdle",
        url: "https://www.larrybirdle.com",
        description:
            "I started playing <a href='https://poeltl.dunk.town'>Poeltl</a> by Dunk Town but it would only let me play once a day. I realised I could easily recreate the game, so I spent about 4 hours at my desk and came out with <a href='https://larrybirdle.netlify.app'>Larry Birdle</a>. Enjoy!",
        platform: ["web"],
        short: "larrybirdle",
    },
    {
        title: "Hedge",
        url: "https://apps.apple.com/ca/app/hedge-bet-on-yourself/id1626661928",
        description:
            "I made this app in the summer of 2022. With sports betting recently becoming legal in Ontario, almost every ad on TV and the internet was for a betting app. My friends and I being big sports fans decided to try them out and we all quickly learned that there was a lot more to betting on sports than just liking a team or a player.<br><br> While stuck together in our university house during a pandemic for a whole school year, watching sports and betting became a regular and consistent part of our school lives as we often made jokes and fake bets on each other. <br><br>Once I finished my final exams, I decided I was going to make an app to do all of this for us during the Summer. After 6 days of work, v1.0.0 of Hedge was ready.",
        platform: ["ios"],
        short: "hedge",
    },
    {
        title: "spllit",
        url: "https://www.larrybirdle.com",
        description:
            "I made this app in the summer of 2021 after discussing how to split our grocery bills with my housemates.<br><br>Everyone had said they didn't want to split all bills equally in case certain people consistently spent more money, but everyone also didn't want to be the one to say they wouldn't split bills.<br><br> We came to the conclusion that if we had an app to keep track of this, we could be more organized and fair.<br><br>Thus, 4 long nights of Xcode and Firebase later, came spllit.<br><br>Check out the source code <a href='https://github.com/jtepp/spllit'>here!</a>",
        platform: ["ios"],
        short: "spllitplease",
    },
    {
        title: "Oooh",
        url: "https://oooh.tv",
        description:
            "Oooh is a new social media platform on the rise which aims to provide a safe space for all (including younger users) and also aims to make content creation easier than ever. <br><br>Oooh has a collection of modules (games, utilities, and other applets) available for their users. These modules can be hosted or joined by anyone. Players can use this platform to compete against eachother or share their favorite things.<br><br>Over the summer of 2022, I worked on the module called Caption This! which is a meme making utility module on Oooh. After my project was completed, I was offered (and accepted) a short extension to work on a similar project for the platform.<br><br> The Oooh platform runs on Unity (currently iOS only), and most of their modules (including the ones I worked on) are written in HTML/CSS/JS",
        platform: ["web"],
        short: "oooh",
        job: {
            title: "Game Developer Intern",
            project: "Caption This!",
            year: "2022",
        },
    },
    {
        title: "Alexander Academy",
        url: "https://alexanderacademy.net",
        description:
            "Alexander Academy is a tutoring company based in Atlanta, New York, and Boston.<br><br>Through Pangea.app, I was hired to work on their new site using Webflow and a lot of custom code. While working on this project, I brought several custom components from idea to code, including custom nested dropdown menus with checkboxes, a 3-dimensional tri-fold pamphlet, a custom image lightbox, and more. Most of this project was translating Figma designs to HTML/CSS/JS, though there were several places where my own creativity was implemented.",
        platform: ["web"],
        short: "alexander",
        job: {
            title: "Front-End Web Developer",
            project: "Website Redesign",
            year: "2021",
        },
    },
    {
        title: "Defiant Regime",
        url: "https://defiantregime.com",
        description:
            "Defiant Regime is a young, Toronto-based, activist, athleisure clothing brand.<br><br>Through LinkedIn, I was hired as an unpaid-intern to work on their new Webflow/Shopify site for their upcoming “By Any Means” collection. The majority of this project was translating Adobe Xd designs to webpages, but I also set up Shopify integration and a customer email signup form.<br><br>My internship ended as I had to start my next semester of school, but I was offered a paid position which I declined.",
        platform: ["web"],
        short: "defiant",
        job: {
            title: "Full-Stack Web Developer",
            project: "Website Redesign",
            year: "2021",
        },
    },
    {
        title: "Rocketeer",
        url: "https://apps.apple.com/us/app/rocketeer/id1569104880",
        description:
            "This iOS application I helped create provides quick and extensive information on upcoming space missions around the world. The motivation behind it was to provide this information easily to a homescreen widget.<br><br>Check out the function that runs the backend <a href='functions#missionstest'>here!</a><br><br>Check out the source code <a href='https://github.com/wildchild9/rocketeer'>here!</a>",
        platform: ["ios"],
        short: "rocketeer",
    },
    {
        title: "iCons",
        url: "https://github.com/jtepp/icons",
        description:
            "As part of the APSC 100/103 course, I created applications for both <a href='https://github.com/jtepp/icons-ios'>iOS</a> and <a href='https://github.com/jtepp/icons'>Android</a>, as well as a <a href='https://iconsportal.netlify.app'>staff portal</a> for the Queen's <a href='https://icon.engsoc.queensu.ca/'>iCons service</a>.<br><br>Check out the <a href='https://github.com/jtepp/icons'>repository</a> for more info.",
        platform: ["ios", "Android"],
        short: "icons",
        job: {
            project: "Equipment Rental App",
            year: "2021",
        },
    },
    {
        title: "Clearly Canadian",
        url: "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=705d9164fa17473086b5238b0b45c346&metadata=01",
        description:
            "I designed and created this Snapchat lens in the summer of 2020 to help promote the classic flavoured sparkling water company <a href='https://clearlycanadian.com'>Clearly Canadian</a>, and their hashtag #ClearlyInMyHands. The lens currently has about 20,000 views!<br><br>Check out the source code <a href='https://github.com/jtepp/clearly'>here</a>.",
        platform: ["ios", "Android"],
        short: "clearly",
        job: {
            project: "Snapchat Lens",
            year: "2020",
        },
    },
    {
        title: "Datamuse",
        url: "https://datamuse.netlify.app",
        description:
            "Using <a href='https://www.datamuse.com/'>Datamuse's</a> API, this site provides the tools necessary to finally figure out that word on the tip of your tongue.",
        platform: ["web"],
        short: "datamuse",
    },
    {
        title: "Geppetto",
        url: "https://github.com/jtepp/geppetto",
        description:
            "Generative Pre-trained Transformer 3 <a href='https://beta.openai.com/'>(GPT-3)</a> is the latest innovation in AI. OpenAI trained this model on 175 billion parameters, making it one of the most complex ML models ever publicly released. Geppetto is an iOS app that lets you submit prompts to the Da Vinci model within GPT-3. The beta program is currently very selective and slowly releasing invitations, so unless you have an API key, Geppetto is quite useless.",
        platform: ["ios"],
        short: "geppetto",
    },
    {
        title: "Wiki",
        url: "https://github.com/jtepp/wiki",
        description:
            "This project was inspired by <a href='https://www.sixdegreesofwikipedia.com/'>sixdegreesofwikipedia.com</a>. Using Swift for command line and the <a href='https://developer.apple.com/documentation/naturallanguage'>Swift Natural Language framework</a>, Wiki does its best to find a path between any two Wikipedia pages. It is slightly hindered by the language framework, meaning it won't really understand anything that isn't in extremely basic English (hence the icon).",
        platform: ["ios"],
        short: "wiki",
    },
    {
        title: "Balance",
        url: "https://github.com/jtepp/Balance",
        description:
            "This app makes use of <a href='https://coinbase.com'>Coinbase</a>'s Node.js API to provide a simple cryptocurrency tracking experience. The motivation behind this app was to improve upon the Coinbase app's own widget. Their widget will only show you current prices on your homescreen, while the Balance widget will show your current balances as well.",
        platform: ["ios"],
        short: "balance",
    },
    {
        title: "Widgit",
        url: "https://github.com/jtepp/Widgit",
        description:
            "This app is another iOS homescreen widget app, but built for Reddit. It provides a fully customizable widget that picks the top photos and posts from Reddit based off all your given criteria.<br><br>Check out the function that runs the backend <a href='functions#redtest'>here!</a>",
        platform: ["ios"],
        short: "widgit",
    },
    {
        title: "Dr. Java",
        url: "https://drjava.netlify.app/",
        description:
            "Inspired by the classic Java IDE of the same name, this incredibly knowledgeable therapist will be more helpful than any other therapist out there. He may not really understand anything at all, but he'll surely make you forget what you came for.",
        platform: ["web"],
        short: "drjava",
    },
    {
        title: "AllPurpose",
        url: "https://allPurpose.netlify.app/",
        description:
            "This site is what I use to host the majority of <a href='functions'>my functions</a>. The project title links to the Github repository because these functions are actually all hosted behind the site you're currently reading.",
        platform: ["web"],
        short: "allpurpose",
    },
];
